import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject, finalize, takeUntil } from 'rxjs';
import { AppModeService } from 'src/app/services/app-mode.service';
import { Address, AddressService } from 'src/app/services/address/address.service';
import { AuthService } from 'src/app/services/auth/auth.service';

@Component({
  selector: 'app-addresses-page',
  templateUrl: './addresses-page.component.html',
  styleUrls: ['./addresses-page.component.css'],
})
export class AddressesPageComponent implements OnInit, OnDestroy {
  private readonly destroy$ = new Subject<void>();

  addresses: Address[] = [];
  isLoading = true;
  errorMessage = '';

  constructor(
    private readonly router: Router,
    public readonly appModeService: AppModeService,
    private readonly authService: AuthService,
    private readonly addressService: AddressService
  ) {}

  ngOnInit(): void {
    const lang = localStorage.getItem('lang') || 'en';

    if (!this.appModeService.isApp()) {
      this.router.navigateByUrl(`/${lang}/home`);
      return;
    }

    if (!this.authService.isLoggedIn()) {
      this.router.navigateByUrl(`/${lang}/home`);
      return;
    }

    this.loadAddresses();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  loadAddresses(): void {
    this.isLoading = true;
    this.errorMessage = '';

    this.addressService
      .getAddresses()
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => {
          this.isLoading = false;
        })
      )
      .subscribe({
        next: (addresses) => {
          this.addresses = addresses;
        },
        error: () => {
          this.errorMessage = 'PROFILE.ADDRESSES.ERROR_LOAD_FAILED';
        },
      });
  }

  goBack(): void {
    const lang = localStorage.getItem('lang') || 'en';
    this.router.navigateByUrl(`/${lang}/profile`);
  }

  navigateToAdd(): void {
    const lang = localStorage.getItem('lang') || 'en';
    this.router.navigateByUrl(`/${lang}/profile/address/new`);
  }

  onEditAddress(id: string): void {
    const lang = localStorage.getItem('lang') || 'en';
    this.router.navigateByUrl(`/${lang}/profile/address/${id}/edit`);
  }
}
